import React, { Component } from 'react'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Config from '../../commons/config/Config.js'
import Dialog from '../../commons/dialog/Dialog.js'
import DropzoneComponent from 'react-dropzone-component/dist/react-dropzone'
import 'react-dropzone-component/styles/filepicker.css'
import 'dropzone/dist/min/dropzone.min.css'
import '../../assets/css/vec-dropzone.css'
import $ from 'jquery'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import swal from 'sweetalert2';
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import { Redirect } from 'react-router-dom'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class OTImport extends Component {
	constructor(props) {
		super(props);
		this.props = props;

		if(props.ticket) {
			this.ticket = props.ticket;
		}

		this.state = {
			ticketProcesados: null,
			archivo: null,
			filename: null,
			tipo: 'VENCIMIENTO',
			tiposArchivos: [{value:"VENCIMIENTO", label: this.props.intl.formatMessage({ id: 'oTImport.tiposArchivos_vencimientos', defaultMessage: 'VENCIMIENTO' })}]
		};

		this.formValidation = new FormValidation({
			component: this,
			validators: {
        'tipo': (value) => Validator.notEmpty(value),
        'archivo': (value) => Validator.notEmpty(value)
       }
    });

		this.initFileUpload();

		this.handleTipoChange = this.handleTipoChange.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleDownloadFile = this.handleDownloadFile.bind(this);

		this.dropzone = null;
	}

	componentDidMount() {

		this.ajaxHandler = new AjaxHandler();
		this.ajaxHandler.subscribe(this);
		if(this.props.onRef) this.props.onRef(this);
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
		if(this.props.onRef) this.props.onRef(undefined);
	}


	handleTipoChange(tipo) {
		this.setState({
			tipo: tipo
		});

		if(tipo)
			this.fileUploadConfig.postUrl = Config.get('apiUrlBase') + '/ordenestrabajo/importar-excel/'+tipo.value+'/'+this.props.match.params.id;
	}

	handleDownloadFile(tipo, e){
		if(tipo){
			this.ajaxHandler.fetch('/ordenestrabajo/documents/'+tipo+'-Modelo.xls', {
				method: 'GET',
			}).then(response => {
				if (response.status === 200) {
					return response.blob();
				} else{
					this.handleImportCancel();
					swal(this.props.intl.formatMessage({ id: 'oTImport.download_file.information_no_se_pudo_obtener_el_documento', defaultMessage: 'No se pudo obtener el documento' }), this.props.intl.formatMessage({ id: 'oTImport.download_file.information_contacte_al_administrador', defaultMessage: 'Contacte al Administrador' }), 'error');
				}
			}).then(fileBlob => {
				let fileUrl = URL.createObjectURL(fileBlob);
				$("<a />", {
					href: fileUrl,
					download: tipo+"-Modelo.xls"
				}).appendTo("body").get(0).click();
			}).catch(() => {
			}).finally(() => {
				this.handleImportCancel();
				this.setState({ loading: false });
			});
		}
	}

	handleRemoveAdjunto(adjunto) {
		this.ajaxHandler.fetch('/ordenestrabajo/adjunto/' + adjunto, {
			method: 'DELETE'
		}).then(response => {
			this.setState({
				archivo: null
			});
		}).catch(() => {});
	}

	initFileUpload() {
		let component = this;

		this.fileUploadConfig = {
			iconFiletypes: ['.xlsx'],
			showFiletypeIcon: true,
			postUrl: Config.get('apiUrlBase') + '/ordenestrabajo/importar-excel/'+component.state.tipo+'/'+component.props.match.params.id
		};

		this.fileUploadDjsConfig = {
			addRemoveLinks: false,
			thumbnailMethod: 'crop',
			dictDefaultMessage: component.props.intl.formatMessage({ id: 'oTImport.add_file.label_haga_click_aqui_o', defaultMessage: 'Haga click aquí o' })+"<br>"+component.props.intl.formatMessage({ id: 'oTImport.add_file.label_arrastre_un_archivo_a_este_area', defaultMessage: 'arrastre un archivo a este área' })+"<br>"+component.props.intl.formatMessage({ id: 'oTImport.add_file.label_para_cargarlo_en_la_categoria_seleccionada', defaultMessage: 'para cargar los datos.' }),
			uploadMultiple: false,
			parallelUploads: 1,
			acceptedFiles: ".xlsx",
			headers: {
				"Authorization-Token": localStorage.getItem("token")
			},
			previewTemplate: `
		        <div class="dz-preview dz-image-preview">
		          <div class="dz-image">
		            <img data-dz-thumbnail src="/images/file.png" />
		          </div>
		          <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress="" style="width: 0%;"></span></div>
		          <div class="dz-success-mark">
		            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Check</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>      </g>    </svg>
		          </div>
		          <div class="dz-error-mark">
		            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Error</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>        </g>      </g>    </svg>
		          </div>
		          <div class="dz-error-message"><span data-dz-errormessage></span></div>
		          <div class="dz-filename" style="width: 120px;"><span data-dz-name title="data-dz-name"></span></div>
		          <div class="dz-remove"><a href="" data-dz-remove>ELIMINAR</a></div>
		        </div>
		  `,
			init: function() {
				let dropzone = this;

				this.on('success', (file, response) => {
					if (component.state.filename!=null) {
						component.handleRemoveAdjunto(component.state.filename);
					}
					component.setState({
						ticketProcesados: response.auditExcel,
						filename: response.filename,
						archivo: file
					});
				});

				this.on('error', (file, errormessage, response) => {
					dropzone.removeFile(file);
					Dialog.alert(component.props.intl, {
						title: errormessage.detalle[0]
					});
				});

				this.on('removedfile', (file) => {
					component.handleRemoveAdjunto(component.state.filename);
					component.setState({
						archivo: null,
						ticketProcesados: null,
						filename: null
					});
				});

				this.on('addedfile', function(file) {
					if (this.files.length > 1) {
							this.removeFile(this.files[0]);
						}
						$(file.previewElement).find('.dz-image').on("click", function() {
							dropzone.hiddenFileInput.click();
						});
				});
			}
		};

	}

	handleCancel(event) {
		this.handleRemoveAdjunto(this.state.filename);
		this.exit();
	}

	exit() {
		this.setState({
			tipo: null,
			archivo: null,
			redirectTo: '/ordenestrabajo'
    });
	}

	handleSave(event) {
		this.ajaxHandler.fetch('/ordenestrabajo/process-excel/'+this.state.tipo+'/'+this.props.match.params.id+'/' + this.state.filename, {
			method: 'POST',
			headers: {
				"Authorization-Token": localStorage.getItem("token")
			}
		}).then(response => {
			if (response.status === 200) {
				Dialog.alert(this.props.intl, {
					title: this.props.intl.formatMessage({ id: 'oTImport.add_file.informatio_actualizacion_exitosa', defaultMessage: 'Actualización exitosa' }),
					text: this.props.intl.formatMessage({ id: 'oTImport.add_file.informatio_su_archivo_fue_procesado_exitosamente.', defaultMessage: 'Su archivo fue procesado exitosamente.' }),
					icon: 'success'
				});
			}
		}).catch(() => {});
		this.ajaxHandler.unsubscribe();

		event.preventDefault();
	}

	render() {
		let state = this.state;

		this.formValidation.validate();
		let validationState = this.formValidation.state;
		let divStyle = {
			'height': '300px',
			'overflowY': 'auto'
		};

		return (
				<React.Fragment>
					{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
					<div className="card pull-up">
						<div className="card-content pl-1 pr-1">
							<div className="card-body">
								<h4 className="form-section">
									<i className="la la-file"></i><FormattedMessage id="oTImport.render.descargar_modelo.header_descargar_modelo" defaultMessage=" Descargar Modelo"/>
								</h4>
								<div className="content-body">
										<button className="btn btn-primary mr-1 col-5" onClick={(e) => this.handleDownloadFile('OTVencimiento', e)} title={this.props.intl.formatMessage({ id: 'oTImport.render.descargar_modelo.button_title_descargar', defaultMessage: 'Descargar' })} >
											<FormattedMessage id="oTImport.render.descargar_modelo.label_modelo_orden_de_trabajo" defaultMessage="Modelo Orden de Trabajo - Vencimientos"/>
										</button>
								</div>
							</div>
						</div>
					</div>
					<div className="card pull-up">
						<div className="card-content pl-1 pr-1">
							<div className="card-body">
								<h4 className="form-section">
									<i className="la la-file"></i><FormattedMessage id="oTImport.render.descargar_modelo.label_importar_archivo" defaultMessage=" Importar Archivo"/>
								</h4>

								<div className="row chat-application ml-0 mr-0 mb-1" style={{border: 0}}>
									<div className="content-body">

										<div className="row" style={{display: 'none'}}>
												<label className="col-md-2 label-control col-form-label text-nowrap" htmlFor="tipo">
													<FormattedMessage id="oTImport.render.descargar_modelo.label_tipo_de_tickets" defaultMessage="Tipo de Tickets "/>*:
												</label>
												<div className="col-md-4">
													<Select
														id="tipo"
														name="tipo"
														placeholder={this.props.intl.formatMessage({ id: 'oTImport.render.descargar_modelo.placeholder_tipo_de_tickets', defaultMessage: 'Seleccione' })}
														options={this.state.tiposArchivos}
														valueKey='value'
														labelKey='label'
														value={this.state.tipo}
														onChange={(e) => this.handleTipoChange(e)}
														menuContainerStyle={{maxHeight: '80px'}}
													/>
													<div className="help-block text-danger field-message" hidden={validationState.tipo.pristine || validationState.tipo.valid}>{validationState.tipo.message}</div>
												</div>
										</div>
										<div className="row mt-1">
											<div className="col-md-12">
												<DropzoneComponent id="archivos" config={this.fileUploadConfig} djsConfig={this.fileUploadDjsConfig} />
												<div className="help-block text-danger" hidden={validationState.archivo.pristine || validationState.archivo.valid}>{validationState.archivo.message}</div>
											</div>
										</div>
										{this.state.archivo ? (
											<React.Fragment>
												<div className="text-center">
													<b><FormattedMessage id="oTImport.render.descargar_modelo.label_orden_trabajo: " defaultMessage="Orden Trabajo: "/>{this.props.match.params.id}</b>
												</div>
												<div className="row mt-1">
													<div className="col-md-12" style={divStyle}>
														<ul className={"list-group"}>
															{this.state.ticketProcesados ? this.state.ticketProcesados.map((ticket, index) => (
																<li key={index} className={"list-group-item list-group-item-" + (ticket.observacion === "Aprobado" ? 'success' : 'danger')}>
																	<b>Ticket:</b> {ticket.id_ticket} - <b>Fecha Vencimiento:</b> {ticket.fecha_vencimiento.substring(8, 10) + '/' + ticket.fecha_vencimiento.substring(5, 7) + '/' + ticket.fecha_vencimiento.substring(0, 4)} - <b>Observacion:</b> {ticket.observacion}
																</li>
															)) : null}
														</ul>
													</div>
												</div>
											</React.Fragment>
												) : (
													<div><FormattedMessage id="oTImport.render.descargar_modelo.information_no_hay_archivos_cargados" defaultMessage="No hay archivos cargados."/></div>
												)}
									</div>
								</div>
							</div>
							<div className="card-footer">
								<div className="text-cd text-right">
										<button type="submit" className="btn btn-primary mr-1" onClick={this.handleSave} disabled={!validationState.form.valid}>
											<i className="fa fa-check-circle"></i><FormattedMessage id="oTImport.finish_button.guardar" defaultMessage=" Guardar"/>
										</button>
										<button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
											<i className="fa fa-times-circle"></i> {this.state.archivo ? ( this.props.intl.formatMessage({ id: 'oTImport.finish_button.cancelar', defaultMessage: 'Cancelar' } )) : ( this.props.intl.formatMessage({ id: 'oTImport.finish_button.volver', defaultMessage: 'Volver' } ) )}
										</button>
									</div>
							</div>
						</div>
					</div>
				</React.Fragment>)}
}

export default injectIntl(OTImport);
